import React from "react";
import { motion } from "framer-motion";
import "../../assets/fonts/fonts.css";

export default function LoadingPage() {
  return (
    <div className="fixed inset-0 bg-white flex justify-center items-center z-50">
      {/* Loading animation */}
      <motion.div
        className="w-14 h-14 border-4 border-t-transparent border-cyan-500  rounded-full animate-spin"
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
      ></motion.div>
    </div>
  );
}
